__turbopack_context__.v({
  "actions": "RSVPModal-module-scss-module__YhpFWW__actions",
  "attendanceOptionTitle": "RSVPModal-module-scss-module__YhpFWW__attendanceOptionTitle",
  "cancelButton": "RSVPModal-module-scss-module__YhpFWW__cancelButton",
  "content": "RSVPModal-module-scss-module__YhpFWW__content",
  "noteField": "RSVPModal-module-scss-module__YhpFWW__noteField",
});
